
<template>
  <div class="advertising" v-if="showBannerAdvertising">
    <banner-advertising-slide-content v-if="$tenant.advertising.type == 'default' && isAllowed('default')" />
    <ad-spirit-advertising v-if="$tenant.advertising.type == 'adspirit' && isAllowed('adspirit') && consentGiven('AdSpirit')"/>
  </div>
</template>

<script>
import BannerAdvertisingSlideContent from "@/widgets/BannerAdvertisingSlideContent";
import AdSpiritAdvertising from "@/widgets/AdSpiritAdvertising";

export default {
  name: "AdvertisingContent",
  components: {
    BannerAdvertisingSlideContent,
    AdSpiritAdvertising,
  },
  data: function () {
    return {
    };
  },
  props: {
    only: {
      type: Array,
      default: null
    }
  },
  mounted: function () {},
  computed: {
    showBannerAdvertising: function () {
      return (
        (this.$store.state.advertising.banner.enabled ||
          this.$store.state.advertising.forceAdvertising)
      );
    },
  },
  methods: {
    isAllowed(type) {
      if (this.only) {
        return this.only.indexOf(type) != -1
      }
      return true
    },
    consentGiven(consentType) {
      return this.$store.state.cookieConsent[consentType] == true
    }
  },
};
</script>
<style scoped>
</style>
